import { render, staticRenderFns } from "./TableContentAsLink.vue?vue&type=template&id=1a6cb30e"
import script from "./TableContentAsLink.vue?vue&type=script&lang=js"
export * from "./TableContentAsLink.vue?vue&type=script&lang=js"
import style0 from "./TableContentAsLink.vue?vue&type=style&index=0&id=1a6cb30e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports